<template>
    <div class="radio-group">
        <label class="form-label mb-1" v-if="heading.length">{{heading}}</label>
        <div class="row">
            <div class="col-xl-6 pt-2 pt-md-3" v-for="label in labels">
                <div class="form-group mb-0 d-flex justify-content-between align-items-center">
                    <label class="form-label ml-0" v-if="slotName === 'label'">{{label.title}}</label>
                    <switch-button
                            :name="'radio'"
                            :checked="label.value"
                            :classes="classes"
                            v-model="label.value"
                            @change="change"
                            :key="label.id"
                    >
                        <template :slot="slotName">
                            <span :class="[ labelClasses ? labelClasses : 'radio-title',  slotName === 'after' ? 'ml-2' : ''   ]">{{label.title}}</span>
                        </template>
                    </switch-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SwitchButton from "./SwitchButton";

    export default {

        props: {
            classes: String,
            labelClasses: {
                type: String,
                default: null
            },
            heading: String,
            labels: Array,
            selectedValues: Array,
            slotName: {
                default: 'after',
                type: String
            }

        },

        data() {
            return {}
        },

        components: {
            SwitchButton,
        },


        beforeMount() {
            this.value = this.checked
        },

        mounted() {
            this.$emit('input', this.value);
        },

        created() {
            this.getSelected();
        },

        watch: {
            value(val) {
                this.$emit('input', val)
            },
            checked(val) {
                this.value = val
            },
            'labels': function () {
                let selectedIds = _.map(this.selectedValues, 'id');
                _.forEach(this.labels, function (label) {
                    if (selectedIds.includes(label.id)) {
                        label.value = true;
                    }
                });
            },
            'selectedValues': function () {
                let selectedIds = _.map(this.selectedValues, 'id');
                _.forEach(this.labels, function (label) {
                    label.value = false;
                    if (selectedIds.includes(label.id)) {
                        label.value = true;
                    }
                });
            }
        },

        methods: {
            change(obj, value) {
                this.$emit('change', obj, value);
            },

            getSelected() {
                let selectedIds = _.map(this.selectedValues, 'id');
                _.forEach(this.labels, function (label) {
                    label.value = false;
                    if (selectedIds.includes(label.id)) {
                        label.value = true;
                    }
                });
            }
        },

        computed: {}

    }
</script>


// WEBPACK FOOTER //
// resources/js/components/form/RadioGroup.vue